import React from 'react';

export const IcelandAirwaves = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="167"
      height="25"
      x="0"
      y="0"
      enableBackground="new 0 0 167 25"
      version="1.1"
      viewBox="0 0 167 25"
      xmlSpace="preserve"
    >
      <g fill="#163e63">
        <path d="M165 19H167V25H165z"></path>
        <path d="M77 3H79V13H77z"></path>
        <path d="M81 3H83V13H81z"></path>
        <path d="M81 11H91V13H81z"></path>
        <path d="M81 3H91V5H81z"></path>
        <path d="M93 3H95V13H93z"></path>
        <path d="M101 3H103V9H101z"></path>
        <path d="M93 11H103V13H93z"></path>
        <path d="M105 3H107V13H105z"></path>
        <path d="M105 11H115V13H105z"></path>
        <path d="M93 3H103V5H93z"></path>
        <path d="M93 7H103V9H93z"></path>
        <path d="M145 15H147V25H145z"></path>
        <path d="M153 15H155V21H153z"></path>
        <path d="M145 23H155V25H145z"></path>
        <path d="M145 15H155V17H145z"></path>
        <path d="M145 19H155V21H145z"></path>
        <path d="M157 15H159V21H157z"></path>
        <path d="M157 23H167V25H157z"></path>
        <path d="M157 15H167V17H157z"></path>
        <path d="M157 19H167V21H157z"></path>
        <path d="M117 3H119V13H117z"></path>
        <path d="M125 3H127V13H125z"></path>
        <path d="M117 3H127V5H117z"></path>
        <path d="M129 3H131V13H129z"></path>
        <path d="M137 3H139V13H137z"></path>
        <path d="M129 3H139V5H129z"></path>
        <path d="M141 3H143V13H141z"></path>
        <path d="M149 1H151V13H149z"></path>
        <path d="M141 3H151V5H141z"></path>
        <path d="M141 11H151V13H141z"></path>
        <path d="M117 9H127V11H117z"></path>
        <path d="M77 15H79V25H77z"></path>
        <path d="M85 15H87V25H85z"></path>
        <path d="M89 15H91V25H89z"></path>
        <path d="M77 15H87V17H77z"></path>
        <path d="M93 15H95V25H93z"></path>
        <path d="M93 15H103V17H93z"></path>
        <path d="M105 15H107V25H105z"></path>
        <path d="M111 15H113V25H111z"></path>
        <path d="M117 15H119V25H117z"></path>
        <path d="M105 23H119V25H105z"></path>
        <path d="M77 21H87V23H77z"></path>
        <path d="M121 15H123V25H121z"></path>
        <path d="M129 15H131V25H129z"></path>
        <path d="M121 15H131V17H121z"></path>
        <path d="M133 15H135V25H133z"></path>
        <path d="M141 15H143V25H141z"></path>
        <path d="M133 23H143V25H133z"></path>
        <path d="M121 21H131V23H121z"></path>
        <path d="M23.3 25c1.9 0 2.5-1.4 2.1-2.6-.5-1.4-4-11.8-4-11.8s-3.7 11-4.1 12.5c-.7 2.3-3.9 1.4-3.2-1.1.7-2.5 5.3-16.7 5.8-18.4.7-2.3 1.8-3.4 4.1-3.5H12.8c-2 0-3.3 1.4-3.8 3S3.5 20.3 3 21.8c-.6 1.7-1.8 2.8-3 3.2h23.3"></path>
        <path d="M49 8H51V18H49z"></path>
        <path d="M45 12H55V14H45z"></path>
      </g>
    </svg>
  );
};
